
import { Helmet } from 'react-helmet';

import { Container } from "reactstrap";

import QuestionnaireCard from './Card'

const Dashboard = () => (
    <Container fluid>

        <Helmet>
            <title>{`Questionnaire`}</title>
            <meta name="description" content="Questionnaire" />
        </Helmet>

        <QuestionnaireCard />

    </Container>
)

export default Dashboard;